import script from "./data-viewer-content.vue?vue&type=script&setup=true&lang=ts"
export * from "./data-viewer-content.vue?vue&type=script&setup=true&lang=ts"

import "./data-viewer-content.vue?vue&type=style&index=0&id=ad50c8aa&lang=scss"

const __exports__ = script;

export default __exports__